import React from 'react';
import { Sparkles, TrendingUp, CheckCircle2, ArrowRight } from 'lucide-react';

export default function AiSummary() {
  const points = [
    "No temperature excursions",
    "Stable cooling performance",
    "Normal operating conditions",
    "No maintenance concerns"
  ];

  return (
    <div className="w-full bg-white border border-gray-100 rounded-2xl p-6 font-sans shadow-sm flex flex-col justify-between">
      
      {/* Header section with AI sparkle icon */}
      <div className="flex items-center gap-2.5 mb-5">
        <Sparkles className="w-6 h-6 text-[#4F46E5] fill-none" strokeWidth={2} />
        <h3 className="text-[17px] font-bold text-gray-900 tracking-tight">
          Today's Summary (AI)
        </h3>
      </div>

      {/* Alert Banner Container */}
      <div className="bg-[#EBF7EE] rounded-xl p-4 flex items-start gap-3.5 mb-6">
        <div className="p-1 text-[#10B981]">
          {/* Custom chart/trending line icon */}
          <TrendingUp className="w-5 h-5" strokeWidth={2.5} />
        </div>
        <div className="space-y-1">
          <h4 className="text-[16px] font-bold text-[#065F46]">
            Everything looks good!
          </h4>
          <p className="text-[13px] font-medium text-[#065F46] opacity-90 leading-relaxed">
            All equipment is operating within safe temperature ranges.
          </p>
        </div>
      </div>

      {/* Summary Checklist Points */}
      <div className="space-y-4 mb-6 pl-1">
        {points.map((text, index) => (
          <div key={index} className="flex items-center gap-3">
            <CheckCircle2 className="w-[18px] h-[18px] text-[#10B981]" strokeWidth={2} />
            <span className="text-[14px] font-semibold text-[#1E293B]">
              {text}
            </span>
          </div>
        ))}
      </div>

      {/* Bottom Action Footer Button */}
      <div className="border-t border-gray-100 pt-4 mt-auto">
        <button className="w-full flex items-center justify-between text-[#0052FF] font-bold text-[14px] hover:opacity-80 transition-opacity group">
          <span>View full summary</span>
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={2.5} />
        </button>
      </div>

    </div>
  );
}
